import { FC, ReactNode } from 'react'

import * as LabelPrimitive from '@radix-ui/react-label'
import { styled } from 'styled-components'

import { onSurface, onSurfaceVariant } from 'core/styles'

type FormLabelProps = {
  text: ReactNode
  htmlFor?: string
  className?: string
  trailingContent?: ReactNode
}

export const Label: FC<FormLabelProps> = ({ text, htmlFor, className, trailingContent }) => (
  <StyledLabel className={className} htmlFor={htmlFor}>
    {text}
    {trailingContent == null ? null : <TrailingContent>{trailingContent}</TrailingContent>}
  </StyledLabel>
)

export const FormContainer = styled.form`
  display: flex;
  flex-flow: row wrap;
  gap: 16px;

  > * {
    flex: 1 1 100%;
    min-width: 0;
  }
`

export const FormRow = styled.div<{ $variant?: 'horizontal' | 'vertical' }>`
  display: flex;
  flex-direction: ${(p) => (p.$variant === 'horizontal' ? 'row' : 'column')};
  align-items: ${(p) => (p.$variant === 'horizontal' ? 'start' : 'stretch')};
  justify-content: ${(p) => (p.$variant === 'horizontal' ? 'space-between' : 'flex-start')};
  width: 100%;

  ${(p) =>
    p.$variant === 'vertical' &&
    `
      > * {
        width: 100%;
      }
    `}

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }
`

export const StyledLabel = styled(LabelPrimitive.Root)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 2px;
  color: ${onSurfaceVariant};
  font-size: 13px;
  font-weight: 500;
`

const TrailingContent = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  margin-left: 8px;
  color: ${onSurfaceVariant};
  font-size: 11px;
  font-weight: 600;
`

export const FormValue = styled.span`
  color: ${onSurface};
  font-size: 14px;
  font-weight: 600;
`

export const FieldLabel = styled.label`
  display: block;
  padding-bottom: 2px;
  color: ${onSurface};
  font-size: 13px;
  font-weight: 500;
`
